import { useCallback, useEffect, useRef, useState } from 'react';

// #96 (Task 9): aus scope-table.tsx extrahiert — ruhiges, zeilennahes "gespeichert"-Feedback
// (Begründung siehe Kopf-Kommentar dort: kein Toast pro Zeile, stattdessen ein Hinweis direkt
// neben der Aktion). War bisher an den Scope-Haken gebunden; jetzt wiederverwendbar für jede
// erfolgreiche Zeilen-Mutation (u. a. die Testerzuweisung).
//
// Ein einzelner Timeout-Ref reicht: löst der Nutzer eine zweite `flash()` aus, bevor der erste
// Timer abgelaufen ist, ersetzt der neue Erfolg den alten Hinweis ohnehin (immer nur EIN
// frisches Feedback gleichzeitig sinnvoll) — der alte Timer muss dann aber weg, sonst löscht er
// gleich darauf das gerade erst gesetzte neue Feedback.
export function useSavedFlash(durationMs = 2500) {
  const [savedId, setSavedId] = useState<string | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const flash = useCallback(
    (id: string) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setSavedId(id);
      timeoutRef.current = setTimeout(() => setSavedId(null), durationMs);
    },
    [durationMs],
  );

  return { savedId, flash };
}
